<template>
  <v-card>
    <!-- Card Header -->
    <v-card-title primary-title>
      <h3 class="headline mb-0">جزئیات کسب‌وکار</h3>
    </v-card-title>

    <v-card-text>
      <v-row>
        <!-- Company info sidebar -->
        <v-col cols="12" md="2">
          <companie-info :user-info="companyInfo" />
        </v-col>

        <!-- Main tabbed content -->
        <v-col cols="12" md="10">
          <v-card class="pa-4">
            <v-card-title class="headline font-weight-bold">
              جزئیات شرکت
            </v-card-title>

            <v-divider class="my-2" />

            <v-card-text>
              <!-- Tabs Navigation -->
              <v-tabs v-model="tab" grow>
                <v-tab>سندها</v-tab>
                <v-tab>فاکتورها</v-tab>
              </v-tabs>

              <!-- Tabs Content -->
              <v-tabs-items v-model="tab" class="pa-4" :reverse="true">
                <!-- SANADs Tab -->
                <v-tab-item>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-sheet elevation="1" class="pa-3">
                        <div class="subtitle-2">تعداد اسناد ۳۰ روز اخیر</div>
                        <div class="text-h6 font-weight-bold">
                          {{ companyInfo.sanads_in_last_30_days_count }}
                        </div>
                      </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-sheet elevation="1" class="pa-3">
                        <div class="subtitle-2">تاریخ و ساعت آخرین سند</div>
                        <div class="text-h6 font-weight-bold">
                          {{ companyInfo.last_sanad_date || '---' }}
                        </div>
                      </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-sheet elevation="1" class="pa-3">
                        <div class="subtitle-2">ایجاد کننده آخرین سند</div>
                        <div class="text-h6 font-weight-bold">
                          {{ companyInfo.last_sanad_creator_name || '---' }}
                        </div>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-tab-item>

                <!-- Factors Tab -->
                <v-tab-item>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-sheet elevation="1" class="pa-3">
                        <div class="subtitle-2">تعداد حساب‌های ایجاد شده توسط کاربران</div>
                        <div class="text-h6 font-weight-bold">
                          {{ companyInfo.accounts_created_by_user }}
                        </div>
                      </v-sheet>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-sheet elevation="1" class="pa-3">
                        <div class="subtitle-2">تعداد کالاهای ایجاد شده توسط کاربران</div>
                        <div class="text-h6 font-weight-bold">
                          {{ companyInfo.wares_created_by_user }}
                        </div>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import CompanieInfo from "@/components/companies/CompanieInfo.vue";

export default {
  name: "CompanieDetail",

  components: {
    CompanieInfo,
  },

  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      companyInfo: null,
      tab: null,
    };
  },

  mounted() {
    this.getCompanieInfo();
  },

  watch: {
    id() {
      this.getCompanieInfo();
    },
  },
  methods: {
    getCompanieInfo() {
      this.request({
        url: this.endpoint(`sobhanAdmin/companies-details/${this.id}/`),
        method: "get",
        success: (data) => {
          this.companyInfo = data;
        },
      });
    },
  },
};
</script>
